import { Box, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

type LessonInfoProps = {
  course: any
  lesson: any
}

export const LessonInfo = ({ course, lesson }: LessonInfoProps) => {
  const { t } = useTranslation(['global'])

  return (
    <Grid item xs={12} sm={6}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
        <Typography variant="body2" color="text.secondary">
          {t('course')}:
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {course.title}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Lección N°:
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {lesson.order}
        </Typography>
      </Box>
    </Grid>
  )
}
